class InPageNav extends HTMLElement {
  
  constructor() {
    super();
    
    // go through all links in collection nav
    const links = this.querySelectorAll('a');
    
    links.forEach((link) => {
      
      // set link to active when link target is in viewport
      const anchor = document.querySelector(link.getAttribute('href'));
      if (anchor) {
        PCOtheme.Motion.inView(
          anchor,
          (element, enterInfo) => {
            // on enter anchor
            links.forEach((item) => {
              item.classList.remove('active');
            });
            link.classList.add('active');
            
            return (leaveInfo) => {
              // on leave anchor
            }
          },
          {
            margin: "50% 0px 0px 0px"
          }
        );
      }
    });
  }
}
customElements.define('in-page-nav', InPageNav);